export default {
  contact: {
    badge: 'Restons en contact',
    title: 'Prêt à transformer vos opérations flotte ?',
    subtitle: 'Nous sommes là pour vous aider à optimiser la gestion de votre flotte avec une technologie de pointe et un support expert. Discutons de la façon dont nous pouvons faire avancer votre activité.',
    badges: {
      freeConsultation: 'Consultation gratuite',
      customSolutions: 'Solutions sur mesure',
      expertSupport: 'Support expert',
    },
    methodTitle: 'Choisissez votre mode de contact préféré',
    methodSub: 'Nous sommes là pour vous aider via plusieurs canaux',
    emailUs: 'Nous écrire',
    dropUsALine: 'Écrivez-nous à tout moment',
    weGetBack: 'Nous vous répondrons sous 4 heures',
    callUs: 'Nous appeler',
    giveUsACall: 'Appelez-nous pendant les heures de bureau',
    businessHours: 'Lun–Ven 9h–18h',
    contactNow: 'Contacter',
    sendMessage: 'Envoyez-nous un message',
    fillForm: 'Remplissez le formulaire et nous vous répondrons sous 4 heures en heures de bureau.',
    messageSent: 'Message envoyé',
    thanksReachingOut: 'Merci de nous avoir contactés. Nous vous répondrons sous 4 heures en heures de bureau.',
    firstName: 'Prénom',
    lastName: 'Nom',
    emailAddress: 'Adresse e-mail',
    phoneNumber: 'Téléphone',
    companyName: 'Entreprise',
    fleetSize: 'Taille de la flotte',
    subject: 'Sujet',
    message: 'Message',
    submit: 'Envoyer',
    errorGeneric: 'Une erreur s\'est produite. Veuillez réessayer.',
    placeholders: {
      firstName: 'Votre prénom',
      lastName: 'Votre nom',
      email: 'vous@entreprise.com',
      phone: '+33 1 23 45 67 89',
      company: 'Votre entreprise',
      message: 'Décrivez vos besoins...',
    },
    subjects: {
      general: 'Demande générale',
      demo: 'Démo produit',
      pricing: 'Tarifs',
      support: 'Support technique',
      partnership: 'Partenariat',
      enterprise: 'Solution entreprise',
    },
    fleetSizes: {
      small: '1–10 véhicules',
      medium: '11–50 véhicules',
      large: '51–100 véhicules',
      xl: '101–500 véhicules',
      xxl: '500+ véhicules',
    },
    whyContactTitle: 'Pourquoi nous contacter ?',
    whyContactSub: 'Support expert et solutions sur mesure',
    bottomCtaTitle: 'Prêt à transformer vos opérations flotte ?',
    bottomCtaSub: 'Rejoignez plus de 100 entreprises qui font confiance à Geofleet pour la gestion de leur flotte',
    statsHappyCustomers: 'Clients satisfaits',
    statsUptime: 'Disponibilité',
    statsSupport: 'Support',
    viewPricingPlans: 'Voir les offres',
    contactUsNow: 'Nous contacter',
    whyContact: {
      strategic: { title: 'Solutions stratégiques', description: 'Stratégies de gestion de flotte adaptées à votre activité' },
      fast: { title: 'Mise en œuvre rapide', description: 'Configuration et onboarding rapides' },
      expertise: { title: 'Expertise sectorielle', description: 'Des années d\'expérience en optimisation flotte' },
      success: { title: 'Succès prouvé', description: 'Plus de 100 clients satisfaits dans le monde' },
    },
    page: {
      eyebrow: "Parlons-en",
      title: "Parlez à l’équipe Geofleet",
      subtitle: "Parlez-nous de votre flotte et nous vous montrerons comment Geofleet réduit les coûts et les retards de livraison.",
      nextTitle: "Et ensuite ?",
      steps: {
        review: "Nous étudions vos informations et votre flotte.",
        call: "Un spécialiste vous appelle sous 4 heures ouvrées.",
        demo: "Vous recevez une démo et une offre adaptées à votre activité.",
      },
      bookDirect: "Ou réservez un appel directement",
    },
    form: {
      name: "Nom complet",
      email: "E-mail professionnel",
      company: "Entreprise",
      country: "Pays",
      phone: "Téléphone",
      fleetSize: "Combien de véhicules ?",
      message: "Autre chose à nous dire ?",
      messagePlaceholder: "Tournées, outils actuels, ce que vous voulez améliorer…",
      optional: "Facultatif",
      submit: "Être contacté",
      reassurance: "Réponse sous 4 heures ouvrées. Jamais de spam.",
      orEmail: "Vous pouvez aussi écrire à",
      successTitle: "Merci, {{name}} !",
      successBody: "Nous avons bien reçu vos informations et vous appellerons sous 4 heures ouvrées. Envie d’aller plus vite ?",
      bookNow: "Réserver un créneau",
      jobTitle: "Poste",
      jobTitlePlaceholder: "ex. Directeur des opérations",
      jobTitles: {
        founder: "Fondateur / PDG",
        operations: "Directeur des opérations",
        fleet: "Responsable de flotte",
        logistics: "Responsable logistique",
        dispatch: "Responsable dispatch",
        it: "DSI / CTO",
        procurement: "Achats",
      },
      solutions: "Que recherchez-vous ?",
      pickAny: "Choix multiple",
      solutionOptions: {
        route_planning: "Planification des tournées",
        shipment_tracking: "Suivi des expéditions",
        fleet_management: "Gestion de flotte",
        gps_tracking: "Géolocalisation GPS",
        auto_dispatch: "Dispatch et affectation auto",
        proof_of_delivery: "Preuve de livraison",
        driver_app: "Application chauffeur",
        customer_notifications: "Suivi client et WhatsApp",
        dashcam_safety: "Dashcam et sécurité",
        cash_on_delivery: "Paiement à la livraison",
        inventory_hubs: "Stocks et hubs",
        ai_agents: "Agents IA et automatisation",
        analytics: "Rapports et analyses",
        integrations: "Intégrations et API",
      },
      errors: {
        name: "Veuillez saisir votre nom.",
        email: "Veuillez saisir un e-mail valide.",
        phone: "Saisissez un numéro valide pour : {{country}}.",
      },
    },
  },
};
